import GeneralUsers from "./UserDetails/GeneralUsersSideBar";
import React from "react";

export default function UserDetails({ profile }) {
  return <GeneralUsers profile={profile} />;
}
